/**
 * 画面のいちばん上の見出し（docs/06 4-5）。
 *
 * 説明は「この画面で何ができるか」だけを書く。仕組みの用語は出さない（docs/06 原則5）。
 */
import type { ReactNode } from 'react';

export interface PageHeaderProps {
  /** 画面の名前。読み上げにも届くよう見出し（h1）になる */
  title: ReactNode;
  /** 1〜2行の説明 */
  description?: ReactNode;
  /** 右側に置くこの画面の操作 */
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps): ReactNode {
  return (
    <div className="ui-page-header">
      <div className="ui-page-header-text">
        <h1>{title}</h1>
        {description !== undefined ? <p>{description}</p> : null}
      </div>
      {actions !== undefined ? <div className="ui-page-header-actions">{actions}</div> : null}
    </div>
  );
}
